import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import { lowerCase, sentenceCase } from 'globals/utils';
import {
  createStyles,
  TextField,
  TextFieldProps,
  withStyles,
} from '@material-ui/core';
import cn from 'classnames';

interface FsSentenceSelectOptionProps {
  label?: string;
  value: string | number;
}

type FsSentenceSelectProps = TextFieldProps & {
  options: Array<FsSentenceSelectOptionProps>;
  optionCase?: 'lc' | 'sc';
};

export default withStyles(({ spacing, palette }) =>
  createStyles({
    root: {
      '& .MuiInputBase-root': {
        fontSize: 24,
        fontWeight: 300,
        '& .MuiSelect-root': {
          padding: 0,
          // paddingLeft: spacing(0.5),
          // paddingRight: spacing(0.5),
        },
        '&.MuiInput-underline:hover:not(.Mui-disabled):before': {
          borderBottom: `2px solid ${palette.primary.main}`,
        },
      },
      '&.isPlaceholder': {
        '& .MuiInputBase-root': {
          color: palette.grey[400],
        },
      },
    },
  })
)(
  ({
    options,
    optionCase,
    label,
    value,
    SelectProps,
    ...otherProps
  }: FsSentenceSelectProps) => {
    return (
      <TextField
        {...otherProps}
        select
        variant="standard"
        label=""
        value={value}
        SelectProps={{
          ...SelectProps,
          native: false,
          displayEmpty: true,
          label: undefined,
          IconComponent: () => null,
        }}
        className={cn({ isPlaceholder: !value })}
      >
        <MenuItem value="" disabled>
          {label}
        </MenuItem>
        {options.map(({ label: optionLabel, value: optionValue }) => (
          <MenuItem key={`${optionValue}`} value={optionValue}>
            {optionCase === 'lc'
              ? lowerCase(`${optionLabel || optionValue}`)
              : sentenceCase(`${optionLabel || optionValue}`)}
          </MenuItem>
        ))}
      </TextField>
    );
  }
);
